import React from "react";
import { Tag } from "@strapi/design-system/Tag";
import Cross from "@strapi/icons/Cross";
import { useDispatch } from "react-redux";
import { removeFilter } from "../../redux/reducers/widenSearchSlice";
import { getFilterLabel } from "./utils";
import styles from "./FilterChip.module.css";
const FilterChip = ({
  filter
}) => {
  const dispatch = useDispatch();
  const handleRemoveFilter = () => dispatch(removeFilter(filter));
  return /*#__PURE__*/React.createElement("div", {
    className: styles["filter-chip-container"]
  }, /*#__PURE__*/React.createElement(Tag, {
    icon: /*#__PURE__*/React.createElement(Cross, null),
    "aria-hidden": true,
    onClick: handleRemoveFilter
  }, getFilterLabel(filter)));
};
export default FilterChip;